import { useState, useEffect } from "react";
import { Empty, Switch, Tree } from "antd";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useFetch } from "../../Services/useFetch";
import fileclose from "../../assets/img/fileclose.png";
import Header from "../../components/Includes/Header";
import { capitalizeExceptPrepositionsAndLowerCase } from "../../common/CapitalLetter/CapitalLetterWithoutPrepositions";

const { DirectoryTree } = Tree;

const initialState = {
  can_create: false,
  // is_explicit_permission: false,
  can_access: false,
  can_share: false,
  can_move: false,
  can_copy: false,
  can_lock: false,
  can_unlock: false,
  can_comment: false,
  can_rename: false,
  can_delete: false,
  file_copy: false,
  file_move: false,
  file_delete: false,
  file_rename: false,
  file_download: false,
  file_share: false,
  file_view: false,
  file_edit: false,
};

const RolePermissions = () => {
  const { id } = useParams();
  const [getPermission, setPermission] = useState(initialState);
  const [treeDataLeft, setTreeDataLeft] = useState([]);
  const [currentFolderId, setCurrentFolderId] = useState([]);
  const [parentAccess, setParentAccess] = useState();
  const [isAdmin, setIsAdmin] = useState(0);
  const [currentPermissionObj, setCurrentPermissionObj] = useState(null);

  const { userData } = useSelector((state) => state.loginData);
  const userName = localStorage.getItem("userFullName");

  const { request } = useFetch();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);

  const TransformLeftNodes = (apiData) => {
    const transformedData = [];
    const visited = {};

    const buildTree = (parentId) => {
      if (visited[parentId]) {
        return [];
      }
      visited[parentId] = true;
      const children = apiData.filter((folder) => folder.parent_id === parentId);
      const nodes = children
        .map((child) => {
          if (child.hasOwnProperty("document_file_name")) {
            return null;
          } else {
            const node = {
              title: capitalizeExceptPrepositionsAndLowerCase(child.folder_name),
              key: child.id,
              type: child.type,
              parent_id: child?.parent_id,
              is_locked: child?.is_locked,
              permissions: child?.permissions,
              icon: <img src={fileclose} width={17} alt="" loading="lazy" />,
            };
            const nestedChildren = buildTree(child.id);
            if (nestedChildren.length > 0) {
              node.children = nestedChildren;
            }
            return node;
          }
        })
        .filter(Boolean);
      return nodes;
    };
    transformedData.push(...buildTree(0));
    return transformedData;
  };

  const onSwitchChange = (eventName, checked) => {
    setPermission((prev) => ({
      ...prev,
      [eventName]: checked,
    }));
  };

  const handleSubmitChange = async () => {
    try {
      const formData = new URLSearchParams();
      formData.append("folder_id", currentPermissionObj?.key);
      formData.append("user_id", id);
      formData.append("permissions", JSON.stringify(getPermission));
      const response = await request("/brifecase-access-permission", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        notifySuccess(response?.data?.message || "Permission updated successfully");

        await fetchBriefFolderList();
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchBriefFolderList = async () => {
    const newformData = new URLSearchParams();
    newformData.append("user_id", id);

    try {
      const [folderResponse] = await Promise.all([
        request("/master-api-list", "post", newformData, {
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      ]);

      if (folderResponse?.data?.status === "1") {
        // Combine or replace data based on `newVal`
        const folderData = folderResponse?.data?.data || [];

        const apiresponses = [...folderData];
        // Process transformations and selections
        const [transformedDataLeft] = await Promise.all([TransformLeftNodes(apiresponses)]);
        // Update states
        setIsAdmin(folderResponse.data.isAdmin);
        setTreeDataLeft(transformedDataLeft);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchBriefFolderList();
    setCurrentPermissionObj(null);
  }, []);

  const onSelect = (keys, info) => {
    const selectedNode = info?.selectedNodes[0];
    setCurrentPermissionObj(selectedNode);

    if (selectedNode?.permissions?.length > 0) {
      setPermission({
        can_create: Boolean(selectedNode.permissions[0]?.can_create),
        can_access: Boolean(selectedNode.permissions[0]?.can_access),
        can_share: Boolean(selectedNode.permissions[0]?.can_share),
        can_move: Boolean(selectedNode.permissions[0]?.can_move),
        can_copy: Boolean(selectedNode.permissions[0]?.can_copy),
        can_lock: Boolean(selectedNode.permissions[0]?.can_lock),
        can_unlock: Boolean(selectedNode.permissions[0]?.can_unlock),
        can_comment: Boolean(selectedNode.permissions[0]?.can_comment),
        can_rename: Boolean(selectedNode.permissions[0]?.can_rename),
        can_delete: Boolean(selectedNode.permissions[0]?.can_delete),
        file_copy: Boolean(selectedNode.permissions[0]?.file_copy),
        file_move: Boolean(selectedNode.permissions[0]?.file_move),
        file_delete: Boolean(selectedNode.permissions[0]?.file_delete),
        file_rename: Boolean(selectedNode.permissions[0]?.file_rename),
        file_download: Boolean(selectedNode.permissions[0]?.file_download),
        file_share: Boolean(selectedNode.permissions[0]?.file_share),
        file_view: Boolean(selectedNode.permissions[0]?.file_view),
        file_edit: Boolean(selectedNode.permissions[0]?.file_edit),
      });
      is_Parent_accesible(selectedNode);
    }
  };

  // console.log()
  const onExpand = (keys, info) => {
    // console.log('Trigger Expand', keys, info);
  };

  const is_Parent_accesible = async (selectedNode) => {
    if (selectedNode?.parent_id > 0) {
      try {
        const formData = new URLSearchParams();
        formData.append("folder_id", selectedNode?.parent_id);
        formData.append("user_id", id);
        const response = await request("/folder-permission-by-id", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });

        if (response?.data?.status == 1) {
          const is_accessable = response?.data?.data[0]?.permissions[0]?.can_access;
          setParentAccess(is_accessable);
        }
      } catch (error) {
        console.log(error, "error");
      }
    } else {
      setParentAccess(true);
    }
  };

  return (
    <>
      <Header />
      <div className="rolePermission_wrapper bd_doc_folder">
        <div className="roleManagement_wrapper">
          <div className="heading_flex">
            <h3 className="head_title">{`Folder Permission (${userName
              ?.toLowerCase()
              ?.split(" ")
              ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              ?.join(" ")})`}</h3>
          </div>
          <div className="main_sec">
            <div className="nestTree_wrap">
              <DirectoryTree multiple onSelect={onSelect} treeData={treeDataLeft} onExpand={onExpand} />
            </div>

            <div className="inner_wrapper">
              {currentPermissionObj?.permissions?.length > 0 ? (
                <>
                  <div className="title">{currentPermissionObj?.title}</div>
                  <div className="toogle_sec">
                    <div className="tgl_one">
                      <p>Access Folder</p>
                      <Switch
                        checked={!!getPermission?.can_access}
                        onChange={(checked) => {
                          onSwitchChange("can_access", checked);
                        }}
                        disabled={isAdmin || !parentAccess}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Create Folder</p>
                      <Switch
                        checked={!!getPermission?.can_create}
                        onChange={(checked) => {
                          onSwitchChange("can_create", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Rename</p>
                      <Switch
                        checked={!!getPermission?.can_rename}
                        onChange={(checked) => {
                          onSwitchChange("can_rename", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Delete</p>
                      <Switch
                        checked={!!getPermission?.can_delete}
                        onChange={(checked) => {
                          onSwitchChange("can_delete", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Share</p>
                      <Switch
                        checked={!!getPermission?.can_share}
                        onChange={(checked) => {
                          onSwitchChange("can_share", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Move</p>
                      <Switch
                        checked={!!getPermission?.can_move}
                        onChange={(checked) => {
                          onSwitchChange("can_move", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>Lock</p>
                      <Switch
                        checked={!!getPermission?.can_lock}
                        onChange={(checked) => {
                          onSwitchChange("can_lock", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>UnLock</p>
                      <Switch
                        checked={!!getPermission?.can_unlock}
                        onChange={(checked) => {
                          onSwitchChange("can_unlock", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File View</p>
                      <Switch
                        checked={!!getPermission?.file_view}
                        onChange={(checked) => {
                          onSwitchChange("file_view", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Rename</p>
                      <Switch
                        checked={!!getPermission?.file_rename}
                        onChange={(checked) => {
                          onSwitchChange("file_rename", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Copy</p>
                      <Switch
                        checked={!!getPermission?.file_copy}
                        onChange={(checked) => {
                          onSwitchChange("file_copy", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Move</p>
                      <Switch
                        checked={!!getPermission?.file_move}
                        onChange={(checked) => {
                          onSwitchChange("file_move", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Delete</p>
                      <Switch
                        checked={!!getPermission?.file_delete}
                        onChange={(checked) => {
                          onSwitchChange("file_delete", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Download</p>
                      <Switch
                        checked={!!getPermission?.file_download}
                        onChange={(checked) => {
                          onSwitchChange("file_download", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Share</p>
                      <Switch
                        checked={!!getPermission?.file_share}
                        onChange={(checked) => {
                          onSwitchChange("file_share", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                    <div className="tgl_one">
                      <p>File Edit</p>
                      <Switch
                        checked={!!getPermission?.file_edit}
                        onChange={(checked) => {
                          onSwitchChange("file_edit", checked);
                        }}
                        disabled={isAdmin || !parentAccess || !getPermission?.can_access}
                      />
                    </div>
                  </div>
                  {!isAdmin && (
                    <button className="BG_mainButton" onClick={() => handleSubmitChange()}>
                      Save & Change
                    </button>
                  )}
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Empty description="Select the Folder" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RolePermissions;
